import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ShoppingCartDeliveryFormData,
  ShoppingCartPhysicalDeliveryFormData,
} from '@rd/form-builder/types/shopping-cart-delivery-form-data.type';
import { HttpError } from '@rd/types/http-error.type';
import { NydusRecipient } from '@rd/types/nydus-recipient.type';
import { Order } from '@rd/types/order.type';
import { Observable } from 'rxjs';
import * as deliveryDetailActions from '../actions/delivery-details.actions';
import * as checkoutOrderActions from '../actions/order-checkout.actions';
import * as actions from '../actions/order-create.actions';
import { OrderCheckoutState } from '../reducers';
import {
  getCheckoutOrderError,
  getCheckoutOrderLoading,
} from '../selectors/checkout-order.selectors';
import {
  getCurrentOrder,
  getCurrentOrderDeliveryDetails,
  getCurrentOrderError,
  getCurrentOrderLoading,
} from '../selectors/current-order.selectors';
import { getDeliveryDetailsLoading } from '../selectors/delivery-details.selectors';

@Injectable({ providedIn: 'root' })
export class OrderCheckoutFacade {
  constructor(private store: Store<OrderCheckoutState>) {}

  currentOrder$: Observable<Order | null> = this.store.select(getCurrentOrder);

  currentOrderLoading$: Observable<boolean> = this.store.select(
    getCurrentOrderLoading,
  );

  currentOrderError$: Observable<HttpError | null> =
    this.store.select(getCurrentOrderError);

  currentOrderRecipient$: Observable<NydusRecipient> = this.store.select(
    getCurrentOrderDeliveryDetails,
  );

  deliveryDetailsLoading$: Observable<boolean> = this.store.select(
    getDeliveryDetailsLoading,
  );

  checkoutOrderLoading$: Observable<boolean> = this.store.select(
    getCheckoutOrderLoading,
  );

  checkoutOrderError$: Observable<HttpError | null> = this.store.select(
    getCheckoutOrderError,
  );

  // Actions

  createOrderCheckout(): void {
    this.store.dispatch(actions.CreateOrder({}));
  }

  updateDeliveryDetails(
    deliveryDetails: Partial<
      ShoppingCartDeliveryFormData | ShoppingCartPhysicalDeliveryFormData
    >,
  ): void {
    this.store.dispatch(
      deliveryDetailActions.UpdateDeliveryDetails({ deliveryDetails }),
    );
  }

  checkoutOrder(): void {
    this.store.dispatch(checkoutOrderActions.CheckoutOrder());
  }
}
